export default __webpack_public_path__ + "static/media/AfterPhoto5.1b0c0a1d.jpg";